import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import CancellationProvider from '../context/CancellationProvider';
import ClaimProvider from '../context/claim';
import ConfigProvider from '../context/config';
import EndorsementProvider from '../context/EndorsementProvider';
import ErrorProvider from '../context/ErrorProvider';
import PolicyProvider from '../context/policy';
import PremiumReportProvider from '../context/premiumReport';
import RenewalProvider from '../context/RenewalProvider';
import { withProviders } from '../hoc/withProviders';
import CustomAssets from './CustomAssets';
import ApplicationRoutes from './Routes';

const TenantApp = () => {
	return withProviders(
		[
			PremiumReportProvider,
			ClaimProvider,
			EndorsementProvider,
			RenewalProvider,
			CancellationProvider,
			PolicyProvider,
			ConfigProvider,
			ErrorProvider,
		],
		<>
			<CustomAssets />
			<BrowserRouter>
				<ApplicationRoutes />
			</BrowserRouter>
		</>,
	);
};

export default TenantApp;
